<template>
  <div v-if="!noContent" class="left-chart-bottom mb-sm-4 mt-6 mt-sm-0">
    <h6 class="chart-title">
      {{ $t('dashboard.titles.articles') }}
    </h6>
    <div class="settings-tab">
      <div class="left-bottom-list-wrap h-auto">
        <div
          class="single-footer-chart-list"
          v-for="(article, i) in articlesList"
          :key="i"
        >
          <a
            :href="`${$route.path.split('/')[0]}/articles/${article.slug}`"
            target="blank"
            rel="noreferrer"
          >
            <h6 class="ml-0">
              <span style="color: grey">{{ article.date }}</span>
              {{ article.title }}
            </h6>
          </a>
        </div>
      </div>
      <div class="settings-tab-overlay multi-collapse collapse"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    noContent() {
      let containsTitles = this.articlesList.reduce(
        (prev, article) => prev || article.title,
        false
      )
      return this.articlesList.length === 0 || !containsTitles
    },
    ...mapState('ticker', {
      articlesList(state) {
        return (state.articles || []).map((a) => ({
          ...a,
          date: new Intl.DateTimeFormat(this.$i18n.locale).format(
            new Date(a.published_at || a.updated_at || a.created_at)
          ),
        }))
      },
    }),
  },
}
</script>
